import { Chip } from "$components/chip";
import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { useIntl } from "react-intl";
import {
  getProductOrigin,
  NON_PHARMA_ORIGIN,
  type ProductOrigin,
} from "./product-origin";

type Props =
  | { origin: ProductOrigin; externalReferences?: never }
  | {
      origin?: never;
      externalReferences:
        | ReadonlyArray<{ readonly origin: string }>
        | null
        | undefined;
    };

export const ProductOriginBadge: FC<Props> = (props) => {
  const { formatMessage } = useIntl();
  const [nonPharmaFlag] = useFeatureFlag(featureFlags.clinical.nonPharma);

  if (!nonPharmaFlag) {
    return null;
  }

  const origin =
    "origin" in props && props.origin
      ? props.origin
      : getProductOrigin(props.externalReferences);

  if (origin === NON_PHARMA_ORIGIN) {
    return (
      <Chip
        color="primary"
        label={formatMessage({
          id: "inventory.productOrigin.nonPharma.label",
          defaultMessage: "Non-pharma",
        })}
      />
    );
  }

  return (
    <Chip
      color="brand"
      label={formatMessage({
        id: "inventory.productOrigin.pharma.label",
        defaultMessage: "Pharma",
      })}
    />
  );
};
